export default function openUrl(url) {
    window.location.href = url;
}
